export const restaurantOrdersFr = {
  title: {
    deliveryTakeaway: 'Delivery et à emporter',
    deliveryTakeawayConfiguration: 'Configuration Delivery et à emporter',
    orderHistoryDocument: 'Historique des commandes · Delivery et à emporter',
    orderHubEyebrow: 'Centre de commandes',
    operationalManagement: 'Gestion opérationnelle',
  },
  workspace: {
    selectBranchToManage: 'Sélectionnez un établissement pour gérer {{title}}.',
    newOrder: 'Nouvelle commande',
    searchOrderPlaceholder: 'Rechercher une commande…',
    orderTypeAriaLabel: 'Type de commande',
    channelDelivery: 'DELIVERY',
    channelTakeaway: 'À EMPORTER',
    processedAriaLabel: 'Traitées',
    processedTitle: 'Commandes traitées',
    processed: 'Traitées',
    refreshOrdersLabel: 'Actualiser les commandes',
    refreshOrdersTitle: 'Actualiser les commandes',
    attentionLabel: 'À gérer',
    unsupportedStatesAlert:
      '{{count}} commandes ont des statuts API incompatibles avec le nouveau flux de travail.',
    unsupportedStatesHint:
      'Elles apparaissent dans le calendrier mais ne peuvent pas être affectées automatiquement aux colonnes du tableau. Vérifiez les statuts renvoyés par le backend.',
  },
  board: {
    elapsedNow: 'À l’instant',
    elapsedMinutesAgo: 'il y a {{minutes}} min',
    elapsedHoursAgo: 'il y a {{hours}} h',
    elapsedDaysAgo: 'il y a {{days}} j',
    productsCount: '{{count}} articles',
    paymentMethodTitle: 'Mode de paiement',
    orderCardAriaLabel:
      'Commande {{id}} · {{name}}. Entrée pour ouvrir, espace pour déplacer.',
    columnSubtitles: {
      inArrivo: 'Nouvelles commandes à examiner',
      accettato: 'Commandes confirmées',
      inLavorazione: 'Commandes en préparation',
      pronto: 'Prêtes pour le retrait ou la livraison',
    },
    archiveReadyTitle: 'Archiver les commandes prêtes',
    archiveReadyAriaLabel: 'Archiver les commandes prêtes',
    dropHere: 'Déposer ici',
    noOrders: 'Aucune commande',
    orderUpdatedRetry: 'Commande mise à jour. Réessayez avec le statut actuel.',
  },
  detail: {
    orderTitle: 'Commande n° {{id}} · {{channel}}',
    orderDetail: 'Détail de la commande',
    refreshOrderLabel: 'Actualiser la commande',
    refreshOrderTitle: 'Actualiser la commande',
    orderActivityLabel: 'Activité de la commande',
    orderActivityTitle: 'Activité de la commande',
    loadError: 'Impossible de charger la commande.',
    scheduledDelivery: 'Livraison programmée',
    scheduledPickup: 'Retrait programmé',
    deliveryAddress: 'Adresse de livraison',
    pickupPoint: 'Point de retrait',
    emptyAddress: '—',
    outcome: 'Issue :',
    orderDishes: 'Articles de la commande',
    editDishes: 'Modifier les articles',
    allergens: 'Allergènes :',
    perDish: '{{price}} / article',
    deliveryFeeLine: 'Delivery {{fee}}',
    orderUpdatedToast: 'Commande mise à jour.',
    operationFailed:
      'L’opération a échoué. Rechargez les détails et réessayez.',
    moveOrder: 'Déplacer la commande',
    orderNumber: 'Commande n° {{id}}',
    chooseStatus: 'Choisir le statut',
    reopenToStatus: 'Revenir au statut',
    chooseOperationalStatus: 'Choisissez un statut opérationnel',
    orderOutcome: 'Issue de la commande',
    chooseReason: 'Choisissez un motif',
    confirmMove: 'Confirmer le changement',
    notifyCustomer: 'Notifier le client',
    doNotNotify: 'Ne pas notifier',
    unpaidTitle: 'Commande pas encore payée',
    unpaidBody:
      'Cette commande n’est pas encore payée. Voulez-vous vraiment la passer en préparation ?',
    unpaidHint:
      'Le paiement restera en attente. Cette action ne débite pas le client.',
    noActivity: 'Aucune activité enregistrée.',
    depositNotAuthorizedApi:
      'L’acompte n’est pas encore autorisé. Attendez l’autorisation de paiement du client.',
  },
  create: {
    title: 'Nouvelle commande',
    description:
      'Choisissez le service, ajoutez des produits et complétez les informations du client.',
    loadServicesError: 'Impossible de charger les services.',
    loadingServices: 'Chargement des services…',
    publishServiceHint:
      'Publiez un service à emporter ou Delivery dans Configuration.',
    whichService: 'Quel service souhaitez-vous utiliser ?',
    loadingMenuSlots: 'Chargement du menu et des créneaux…',
    loadMenuSlotsError: 'Impossible de charger le menu et les créneaux.',
    noModeAvailable: 'Aucun mode disponible pour ce service.',
    operationFailed: 'L’opération a échoué. Réessayez.',
    addAtLeastOneProduct: 'Ajoutez au moins un produit.',
    productUnavailable: 'Un produit n’est plus disponible.',
    checkProducts: 'Vérifiez les produits.',
    enterCustomerName: 'Saisissez le prénom et le nom du client.',
    enterValidPhone:
      'Saisissez un numéro de téléphone valide avec l’indicatif du pays.',
    fixOrClearEmail: 'Corrigez l’adresse e-mail ou laissez le champ vide.',
    chooseDayAndSlot: 'Choisissez un jour et une heure disponibles.',
    chooseActiveDriver:
      'Choisissez un livreur actif ou laissez « Affecter plus tard ».',
    enterFullDeliveryAddress:
      'Saisissez l’adresse de livraison complète, numéro de rue inclus.',
    reloadService: 'Rechargez le service.',
    quoteExpired:
      'Le devis a expiré. Vérifiez les détails et actualisez le récapitulatif.',
    stepsAriaLabel: 'Étapes de la nouvelle commande',
    steps: {
      service: 'Service',
      products: 'Produits',
      customer: 'Client',
      confirm: 'Confirmer',
    },
    footerProductsTotal: '{{count}} articles · {{total}}',
    footerTotalOrder: 'Total de la commande',
    footerDeliveryInSummary: 'Frais de livraison dans le récapitulatif',
    wait: 'Veuillez patienter…',
    stepActions: {
      chooseProducts: 'Choisir les produits',
      customerDetails: 'Informations du client',
      reviewOrder: 'Vérifier la commande',
      createOrder: 'Créer la commande',
    },
    channelSectionTitle: 'Comment le client recevra-t-il la commande ?',
    channelSectionHint:
      'À emporter : il vient la récupérer. Delivery : nous la livrons.',
    channelTakeaway: 'À emporter',
    channelDelivery: 'Delivery',
    changeChannelConfirm:
      'Changer de mode et vider les produits déjà ajoutés ?',
    whatToOrder: 'Que souhaite-t-il commander ?',
    menuCategoriesAriaLabel: 'Catégories du menu',
    allMenu: 'Menu complet',
    otherProducts: 'Autres produits',
    searchProduct: 'Rechercher un produit',
    searchProductPlaceholder: 'Nom du produit…',
    fromMenu: 'Du menu',
    addProductAria: 'Ajouter {{name}}',
    compose: 'Configurer',
    add: 'Ajouter',
    cartAriaLabel: 'Articles de la commande',
    yourOrder: 'Votre commande',
    chooseProductToStart: 'Choisissez un produit du menu pour commencer.',
    noExtraOptions: 'Aucune option supplémentaire',
    decreaseQtyAria: 'Diminuer la quantité',
    decreaseQtyForAria: 'Diminuer la quantité de {{name}}',
    quantityForAria: 'Quantité de {{name}}',
    increaseQtyForAria: 'Augmenter la quantité de {{name}}',
    anotherConfiguration: 'Autre configuration',
    removeConfigurationAria: 'Supprimer la configuration {{index}}',
    subtotal: 'Sous-total',
    customerAndFulfillment: 'Client et {{fulfillment}}',
    fulfillmentDelivery: 'livraison',
    fulfillmentPickup: 'retrait',
    customerRequiredHint:
      'Le prénom, le nom et le téléphone sont obligatoires.',
    emailOptional: 'E-mail (facultatif)',
    emailPlaceholder: 'client@exemple.com',
    fullAddress: 'Adresse complète',
    fullAddressPlaceholder: 'Rue, numéro, code postal et ville',
    driver: 'Livreur',
    assignLater: 'Affecter plus tard',
    driversLoadError:
      'Impossible de charger les livreurs. Vous pourrez en affecter un plus tard.',
    deliveryTime: 'Heure de livraison',
    pickupTime: 'Heure de retrait',
    bookUntil: 'Vous pouvez réserver jusqu’au {{date}}.',
    notesOptional: 'Notes (facultatif)',
    notesPlaceholder: 'Interphone, instructions pour la cuisine…',
    reviewAndCreate: 'Vérifier et créer la commande',
    driverLine: 'Livreur :',
    toAssign: 'À affecter',
    afterCreateHint:
      'Après la création, vous pourrez gérer la commande et demander un acompte.',
    productConfigHint:
      'Choisissez les ingrédients de cette configuration. Pour des ingrédients différents, ajoutez une autre configuration.',
    requiredSuffix: ' · obligatoire',
    quantity: 'Quantité',
    reduceQuantityAria: 'Diminuer la quantité',
    addToOrder: 'Ajouter à la commande',
    saveChanges: 'Enregistrer les modifications',
    selection: {
      quantityRange: 'Choisissez une quantité comprise entre 1 et 99.',
      productUnavailableForService: 'Produit non disponible pour ce service.',
      optionUnavailable:
        'L’une des options sélectionnées n’est pas disponible.',
    },
    cartErrors: {
      invalidLine: 'Ligne de commande non valide.',
      maxSameConfiguration:
        'Vous pouvez ajouter au maximum 99 unités de la même configuration.',
      maxConfigurations: 'Maximum 100 configurations par commande.',
      configurationsRange: 'Ajoutez entre 1 et 100 configurations.',
      invalidAmountOrPercentage: 'Montant ou pourcentage non valide.',
      checkOrderProducts: 'Vérifiez les produits de la commande.',
      minimumOrder: 'Commande minimum : {{amount}} €.',
      invalidDeliveryFee:
        'Frais de livraison non valides. Rechargez le service.',
    },
  },
  history: {
    selectBranch: 'Sélectionnez un établissement pour afficher les commandes.',
    subtitleDefault: 'Delivery et à emporter',
    searchTitle: 'Rechercher dans l’historique',
    searchHint:
      'Choisissez une période ou recherchez une commande. Les résultats se mettent à jour automatiquement.',
    searchPlaceholder: 'N° de commande, client, produit ou contact…',
    moreFilters: 'Plus de filtres',
    invalidDateRange: 'La plage de dates n’est pas valide.',
    exporting: 'Exportation en cours…',
    exportCsv: 'Exporter en CSV',
    exportFailed:
      'L’exportation a échoué. Aucun fichier partiel n’a été téléchargé. Réessayez.',
    driversListUnavailable: 'Liste des livreurs indisponible.',
    searchUnavailable:
      'Recherche indisponible. Les filtres n’ont pas renvoyé de résultat vérifié.',
    searching: 'Recherche des commandes et des récapitulatifs…',
    exactMatch: 'Correspondance exacte',
    containsMatch: 'Recherche par texte contenu',
    exactMatchHint: 'Les noms plus longs ne sont pas inclus.',
    ordersFound: 'Commandes trouvées',
    ordersFoundHint: 'Selon la période et les filtres sélectionnés',
    completedValue: 'Valeur des commandes terminées',
    completedValueHint:
      '{{count}} commandes terminées · montant total, même si pas encore payées',
    stillUnpaid: 'Encore impayées',
    noUnpaidInResults: 'Aucune commande impayée dans les résultats',
    unpaidInResults: '{{count}} commandes impayées dans les résultats',
    ordersByDriver: 'Commandes par livreur',
    ordersByDriverHint:
      'Responsable actuel, y compris les commandes archivées.',
    driverSummary: '{{completed}} terminées · {{unpaid}} à encaisser',
    orderList: 'Liste des commandes',
    orderListHint: 'Utilisez « Détails » pour ouvrir une commande.',
    resultsPage: '{{total}} résultats · Page {{page}} sur {{pages}}',
    loadingPage: 'Chargement de la page…',
    noOrdersForFilters: 'Aucune commande pour ces filtres',
    table: {
      order: 'Commande',
      dateTime: 'Date et heure',
      channel: 'Canal',
      orderStatus: 'Statut de la commande',
      payment: 'Paiement',
      driver: 'Livreur',
      total: 'Total',
      notAssigned: 'Non affecté',
      openOrderAria: 'Ouvrir la commande {{id}}',
    },
    modalProcessed: 'Commandes traitées',
    modalHistory: 'Historique des commandes',
    filters: {
      paid: 'Payée',
      unpaid: 'Impayée',
      allMethods: 'Tous les modes',
      allDrivers: 'Tous',
      unassigned: 'Non affectée',
      deliveryAndTakeaway: 'Delivery et à emporter',
      allStatuses: 'Tous',
      afterProcessed: 'Statut après traitement',
      sortBy: 'Trier par',
      sortRecent: 'Plus récentes',
      sortOldest: 'Plus anciennes',
      sortTotalHigh: 'Total le plus élevé',
      unassignedOnly: 'Non affectées',
      driverFilter: 'Livreur : {{name}}',
    },
    export: {
      incompleteResults: 'Résultats incomplets. Réessayez.',
      filename: 'historique-commandes.csv',
      headers: {
        order: 'Commande',
        customer: 'Client',
        email: 'E-mail',
        phone: 'Téléphone',
        schedule: 'Livraison / retrait',
        channel: 'Canal',
        products: 'Produits',
        driver: 'Livreur',
        totalEur: 'Total EUR',
        orderStatus: 'Statut de la commande',
        paymentStatus: 'Statut du paiement',
        paymentMethod: 'Mode de paiement',
      },
      productLine: '{{quantity}} × {{name}}',
    },
    pagination: {
      perPage: 'Par page',
      ordersCount: '{{count}} commandes',
      previous: 'Précédent',
      next: 'Suivant',
    },
    topCustomersHint:
      'Top 10 par valeur des commandes terminées, sur tous les résultats filtrés.',
    noCompletedInResults: 'Aucune commande terminée dans les résultats.',
  },
  drivers: {
    manageHint:
      'Gérez les collaborateurs pouvant être affectés aux livraisons.',
    addDriver: 'Ajouter un livreur',
    loadError: 'Impossible de charger les livreurs.',
    empty: 'Aucun livreur configuré',
    columns: {
      driver: 'Livreur',
      phone: 'Téléphone',
      status: 'Statut',
      actions: 'Actions',
    },
    active: 'Actif',
    inactive: 'Inactif',
    ordersAndMap: 'Commandes et carte',
    deleteTitle: 'Supprimer le livreur',
    deleteConfirm:
      'Supprimer {{name}} ? L’accès sera révoqué et les commandes ouvertes ne seront plus affectées. L’historique sera conservé.',
    deleteAction: 'Supprimer le livreur',
    deletedToast: 'Livreur supprimé.',
    deleteError: 'Impossible de supprimer le livreur.',
    editTitle: 'Modifier le livreur',
    newTitle: 'Nouveau livreur',
    username: 'Identifiant',
    passwordNew: 'Mot de passe · au moins 4 caractères',
    passwordKeep: 'Nouveau mot de passe (laisser vide pour conserver l’actuel)',
    passwordMinError: 'Saisissez au moins 4 caractères.',
    accessHint:
      'Le livreur se connecte depuis le bouton du scooter sur le menu public. Communiquez-lui directement les identifiants. Le mot de passe ne sera plus affiché.',
    activeToggleAria: 'Livreur actif',
    activeToggle: 'Livreur actif',
    savedToast: 'Livreur enregistré.',
    saveError: 'Impossible d’enregistrer le livreur.',
    createdByDriver: 'Créée par le livreur :',
    assignedLabel: 'Livreur affecté',
    notAssigned: 'Non affecté',
    deactivatedSuffix: ' · désactivé',
    deletedSuffix: ' · supprimé',
    driverLine: 'Livreur :',
    assignSuccess: 'Livreur affecté',
    unassignSuccess: 'Affectation supprimée',
    assignError: 'Impossible d’affecter le livreur.',
    discountCard: 'Carte de réduction',
    giftCard: 'Carte cadeau :',
    giftCardCaptured: 'Débitée',
    giftCardReleased: 'Libérée',
    giftCardReserved: 'Réservée',
    amountDue: 'À encaisser :',
  },
  config: {
    title: 'Configuration Delivery et à emporter',
    sectionAriaLabel: 'Services à emporter et Delivery',
    introTitle: 'Gérez la façon dont vous recevez les commandes',
    introBody:
      'Utilisez Modifier pour définir le menu, les jours, les horaires et les paiements de chaque service. Partagez le lien ou le code QR pour que les clients puissent commander.',
    searchPlaceholder: 'Rechercher un service…',
    newService: 'Nouveau service',
    templateLoadError: 'Impossible de charger les données initiales.',
    servicesLoadError: 'Impossible de charger les services.',
    emptySearch: 'Aucun service ne correspond à votre recherche',
    empty: 'Aucun service configuré',
    columns: {
      service: 'Service',
      orderType: 'Type de commande',
      visibility: 'Visibilité',
      manageShare: 'Gérer et partager',
    },
    preparationMinutes: 'Préparation {{minutes}} min',
    advanceDays: 'Commandes jusqu’à {{days}} jours à l’avance',
    deliveryPausedSuffix: ' · en pause',
    visibleToCustomers: 'Visible par les clients',
    draftNotVisible: 'Brouillon · non visible',
    openPage: 'Ouvrir la page',
    servicesPerPage: 'Services par page',
    range: '{{start}}–{{end}} sur {{total}}',
    previous: 'Précédent',
    next: 'Suivant',
    linkCopied: 'Lien copié.',
    copyManually: 'Copiez manuellement le lien affiché.',
    removedToast: 'Service supprimé. Les commandes existantes sont conservées.',
    removeError: 'Impossible de supprimer le service.',
    shareModalTitle: 'Lien client · {{name}}',
    published: 'Publié',
    draftPublishHint:
      'Brouillon · publiez le service pour recevoir des commandes',
    publicLinkLabel: 'Lien public Delivery / à emporter',
    shareHint:
      'Le client choisira parmi les canaux activés et les créneaux disponibles pour ce service.',
    removeTitle: 'Supprimer le service',
    removeConfirm:
      'Supprimer « {{name}} » ? Le service n’acceptera plus de nouvelles commandes. Les commandes existantes et l’historique seront conservés.',
    removeAction: 'Supprimer le service',
    editor: {
      editTitle: 'Modifier le service',
      newTitle: 'Nouveau service',
      stepService: '1 · Service',
      stepProducts: '2 · Produits',
      stepSchedulePayments: '3 · Horaires et paiements',
      savePublish: 'Enregistrer et publier',
      saveDraft: 'Enregistrer le brouillon',
      serviceName: 'Nom du service',
      serviceNameHint:
        'Ce nom est le titre de la page publique que les clients ouvrent depuis le lien ou le code QR pour commander en Delivery ou à emporter.',
      chooseMenu: 'Choisir le menu',
      menusLoadError: 'Impossible de charger les menus.',
      enableTakeaway: 'Activer l’emporter',
      enableDelivery: 'Activer Delivery',
      restaurantPhoto: 'Photo du restaurant (facultatif)',
      restaurantPhotoHint:
        'Cliquez pour choisir et téléverser une photo depuis votre appareil.',
      removeRestaurantPhoto: 'Supprimer la photo du restaurant',
      photoLoading: 'Téléversement de la photo…',
      photoUploadedToast:
        'Photo téléversée. Enregistrez le service pour confirmer.',
      photoUploadError: 'Impossible de téléverser la photo du restaurant.',
      photoNoUrl:
        'Le téléversement n’a pas renvoyé l’URL de l’image. Réessayez.',
      productsIntro:
        'Choisissez les produits disponibles et les prix par canal. Les ingrédients et les variantes proviennent du menu partagé. Pour confirmer un prix modifié, cliquez sur Enregistrer à côté du champ.',
      searchProductsPlaceholder: 'Rechercher un produit ou une section…',
      productsLoadError: 'Impossible de charger les produits.',
      productsLoading: 'Chargement des produits…',
      noProducts: 'Aucun produit trouvé',
      chooseMenuFirst: 'Choisissez d’abord un menu',
      sectionControlsHint:
        '{{count}} produits · les commandes s’appliquent à toute la section, même pendant la recherche.',
      partial: ' · Partiel',
      activeCount: '{{enabled}}/{{total}} actifs',
      sectionToggleAria: '{{channel}} : toute la section {{name}}',
      product: 'Produit',
      takeaway: 'À emporter',
      delivery: 'Delivery',
      options: 'Ingrédients et options',
      syncedWithMenu: ' · Synchronisé avec le menu',
      priceAria: 'Prix {{channel}} {{name}}',
      savePriceAria: 'Enregistrer le prix {{channel}} {{name}}',
      invalidPrice: 'Saisissez un prix valide supérieur ou égal à zéro.',
      updateFailed: 'Échec de la mise à jour',
      productsUpdatedPartial:
        '{{completed}} produits sur {{total}} mis à jour. Non mis à jour : {{failures}}',
      priceUpdatedToast: 'Prix mis à jour.',
      productsUpdatedToast: '{{count}} produits mis à jour.',
      menuLoadFailed:
        'Impossible de charger le menu. Aucune modification n’a été appliquée.',
      recipeSyncHint:
        'Les interrupteurs des produits synchronisés mettent à jour la recette immédiatement, y compris dans le menu et dans les autres services qui l’utilisent. Les prix enregistrés ici mettent également à jour le menu et les autres services. Annuler n’annule pas ces modifications. Pour les produits non synchronisés, enregistrez le service pour confirmer. Modifiez les ingrédients dans le menu.',
      prepMinutes: 'Préparation moyenne (min)',
      slotMinutes: 'Durée du créneau de livraison/retrait (minutes)',
      slotHint:
        'Avec 15 minutes, le client peut choisir 19 h 00–19 h 15, puis 19 h 15–19 h 30. Le temps de préparation est défini séparément.',
      advanceDaysLabel: 'Délai maximum de commande (jours)',
      advanceDaysHint:
        'Avec 7 jours, le client peut commander pour une date dans les 7 jours à venir, pendant les horaires d’ouverture configurés.',
      minimumOrder: 'Commande minimum (€)',
      freeDeliveryFrom: 'Livraison gratuite à partir de (€)',
      deliveryRadius: 'Rayon de livraison (km)',
      weeklyCalendar:
        'Calendrier hebdomadaire · horaires de réception des commandes',
      from: 'De',
      slotStartAria: 'Début du créneau {{index}}',
      slotEndAria: 'Fin du créneau {{index}}',
      removeSlotAria: 'Supprimer le créneau',
      addSlot: 'Ajouter un créneau',
      paymentMethods: 'Modes de paiement acceptés',
      cardOnly: 'Carte uniquement',
      cashAndCard: 'Espèces et carte',
      stripeChecking: 'Vérification de Stripe…',
      stripeRequired:
        'Pour activer les paiements par carte, terminez la configuration de Stripe et l’intégration de l’établissement.',
      cardStripeError:
        'Pour activer les paiements par carte, terminez la configuration de Stripe et l’intégration de l’établissement.',
      publication: 'Publication',
      pauseDelivery: 'Suspendre temporairement Delivery',
      pauseDeliveryHint:
        'La section Delivery de ce service peut être désactivée temporairement. Réactivez-la en décochant l’option et en enregistrant le service. L’emporter reste disponible s’il est activé.',
      publishService: 'Publier le service',
      savedPublishedToast: 'Service enregistré comme publié.',
      savedDraftToast: 'Brouillon enregistré.',
      saveError: 'Impossible d’enregistrer le service.',
      pendingPrices:
        'Enregistrez les prix modifiés avec le bouton à côté de chaque champ avant de continuer.',
      distanceBandsUnsupported:
        'L’API associée doit être mise à jour pour enregistrer les tranches de distance.',
      distanceBandsNotReturned:
        'Le serveur n’a pas renvoyé les tranches enregistrées. La configuration reste ouverte : rechargez le service avant de réessayer.',
      productDetailsTitle: 'Détails du produit · {{name}}',
      productDetails: 'Détails du produit',
      closeDetails: 'Fermer les détails',
      ingredients: 'Ingrédients :',
      allergens: 'Allergènes :',
      notSpecified: 'Non précisé',
      noOptionsForChannel: 'Aucune option pour ce canal',
      group: 'Groupe',
      ingredient: 'Ingrédient',
      supplement: 'Supplément',
      minMax: 'Min. {{min}}{{max}}',
      maxSuffix: ' · Max. {{max}}',
      weekdays: {
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',
      },
    },
    validation: {
      serviceName: 'Saisissez un nom de service (120 caractères maximum).',
      chooseMenu: 'Choisissez le menu du service.',
      enableChannel: 'Activez au moins Delivery ou à emporter.',
      integerRange:
        '{{label}} : saisissez un nombre entier compris entre {{min}} et {{max}}.',
      preparation: 'Préparation',
      slotDuration: 'Durée du créneau',
      bookableDays: 'Jours réservables',
      amounts: 'Saisissez des montants positifs avec au plus deux décimales.',
      deliveryRadius:
        'Le rayon de livraison doit être supérieur à 0 et d’au plus 100 km.',
      timezone: 'Saisissez un fuseau horaire valide.',
      location:
        'Complétez l’adresse et les coordonnées dans la configuration de l’établissement.',
      geocoding:
        'Le service de vérification de la zone de livraison n’est pas configuré.',
      openingHours: 'Saisissez entre 1 et 28 plages d’ouverture.',
      openingHoursOrder:
        'Vérifiez les plages d’ouverture : l’heure de fin doit être postérieure à l’heure de début.',
      enableProduct: 'Activez au moins un produit pour un canal actif.',
      productPrices: 'Vérifiez les prix des produits.',
    },
  },
  modals: {
    archive: {
      title: 'Archiver les commandes prêtes',
      intro:
        'Les commandes sélectionnées seront archivées : Delivery comme Livrée, à emporter comme Retirée. Le mode de paiement reste inchangé.',
      markAllPaid: 'Marquer toutes les commandes sélectionnées comme payées',
      deliverySection: 'Delivery · Livrée',
      takeawaySection: 'À emporter · Retirée',
      paid: 'Payée',
      noReadyOrders: 'Aucune commande prête.',
      archiving: 'Archivage en cours…',
      archiveCount: 'Archiver {{count}} commandes',
      archiveError:
        'L’archivage a échoué. Rechargez les commandes et réessayez.',
    },
    processed: {
      title: 'Commandes traitées · {{date}}',
      searchPlaceholder:
        'Rechercher un client, un téléphone ou un n° de commande…',
      orderOutcome: 'Issue de la commande',
      allReasons: 'Tous les motifs',
      empty: 'Aucune commande archivée',
      columns: {
        order: 'Commande',
        channel: 'Canal',
        schedule: 'Heure de livraison / retrait',
        total: 'Total',
        driver: 'Livreur',
        outcome: 'Issue',
        payment: 'Paiement',
      },
      perPage: 'Par page',
      ordersCount: '{{count}} commandes',
      previous: 'Précédent',
      next: 'Suivant',
    },
    payment: {
      cardTitle: 'Paiement par carte',
      loadingStripe: 'Chargement du formulaire Stripe…',
      loadError:
        'Impossible de charger le paiement. La commande est enregistrée et en attente de paiement.',
      retryPayment: 'Réessayer le paiement',
      payAmount: 'Payer {{amount}}',
      confirmedOnPayment:
        'La commande sera confirmée dès réception du paiement.',
      paymentFailed: 'Le paiement a échoué. Réessayez.',
      paymentIncomplete: 'Le paiement n’a pas abouti. Réessayez.',
      verifyFailed:
        'Impossible de vérifier le paiement. Réessayez sur la même commande.',
    },
    itemsEditor: {
      title: 'Modifier les articles',
      titleWithOrder: 'Modifier les articles · Commande n° {{id}}',
      loadError:
        'La modification de la commande nécessite les nouvelles API du backend. Aucune donnée n’a été modifiée.',
      loadingMenu: 'Chargement du menu…',
      notEditable:
        'Cette commande ne peut pas être modifiée dans son statut actuel.',
      saveError:
        'Enregistrement impossible. Rechargez la commande si un autre opérateur l’a modifiée.',
      menuChannel: 'Menu · {{channel}}',
      searchPlaceholder: 'Rechercher un plat ou une section…',
      orderItems: 'Articles de la commande · {{count}}',
      removeDishAria: 'Supprimer le plat',
      quantity: 'Quantité',
      decreaseQtyAria: 'Diminuer la quantité',
      optionIssue:
        'Vérifiez la disponibilité et le minimum/maximum d’ingrédients sélectionnés.',
      addAtLeastOne:
        'Ajoutez au moins un article. Pour annuler la commande, utilisez l’action dédiée.',
      verifiedTotal: 'Nouveau total vérifié',
      recalcHint:
        'Le serveur recalcule les prix et les suppléments avant l’enregistrement. Les modifications restent locales jusqu’à « Enregistrer les modifications ».',
      verifyTotal: 'Vérifier le nouveau total',
      saveChanges: 'Enregistrer les modifications',
      unsavedConfirm:
        'Quitter sans enregistrer les modifications des articles ?',
      dishFallback: 'Article {{index}}',
    },
  },
  address: {
    suggestionsUnavailable:
      'Suggestions indisponibles. Réessayez dans un instant pour sélectionner la rue.',
    searching: 'Recherche d’adresses…',
    suggestionsCount:
      '{{count}} adresses suggérées. Utilisez les flèches pour choisir et Entrée pour confirmer.',
    notFound: 'Aucune adresse trouvée. Vérifiez la rue et ajoutez la ville.',
    verifyStreet: 'Vérification de la rue et du numéro…',
    verifyFailed:
      'Nous n’avons pas pu vérifier la rue. Sélectionnez à nouveau une suggestion pour réessayer.',
    selectFromSuggestions:
      'Sélectionnez la rue parmi les suggestions avant de continuer.',
    deliveryAddressSrOnly: 'Adresse de livraison',
    placeholder: 'Rue, numéro, ville et code postal',
    suggestedAddressesAria: 'Adresses suggérées',
    hint: 'Choisissez la rue parmi les suggestions et complétez le numéro.',
    streetNumber: 'Numéro *',
    streetNumberPlaceholder: 'p. ex. 10, 10/A',
    deliveryAddressPreview: 'Adresse de livraison :',
    yourAddress: 'Votre adresse',
    streetOnlyCity:
      'Sélectionnez une rue parmi les suggestions, pas seulement une ville ou une zone.',
    fullAddressItaly:
      'Sélectionnez une adresse complète avec rue et ville en Italie.',
    streetNumberRequired: 'Saisissez le numéro de rue pour continuer.',
    streetNumberInvalid:
      'Saisissez un numéro valide, p. ex. 10, 10/A ou 10 bis.',
  },
  pricing: {
    ariaLabel: 'Coût de livraison',
    title: 'Comment calculez-vous le coût de livraison ?',
    intro:
      'Choisissez un coût unique pour tous ou un prix total pour chaque tranche de distance.',
    fixedCost: 'Coût fixe',
    distanceBands: 'Tranches de distance',
    fixedFeeLabel: 'Coût par livraison (€)',
    fixedFeeHint:
      'Le même montant pour toutes les adresses situées dans le rayon de livraison.',
    bandsUnsupported:
      'Les API associées ne permettent pas encore d’enregistrer les tranches. Vous pouvez les préparer ici ; l’enregistrement sera disponible après la mise à jour du service.',
    bandsFlow:
      '1. Adresse dans un rayon de {{radius}} km → 2. Itinéraire routier → 3. Coût de la tranche',
    bandsFlowHint:
      'Le prix correspond au coût total de la livraison. Les kilomètres sont la distance routière aller simple entre l’établissement et le client. La dernière tranche couvre toute distance supérieure pour les adresses déjà acceptées.',
    allDistances: 'Toutes les distances',
    overKm: 'Plus de {{km}} km',
    lastBandHint: 'Dernière tranche · aucune limite routière supplémentaire',
    bandUpTo: 'Tranche {{index}} · jusqu’à (km)',
    bandFromZero: 'À partir de 0 km, limite incluse.',
    bandAfterPrevious: 'Après {{km}} km, limite incluse.',
    bandCost: 'Tranche {{index}} · coût total (€)',
    removeBandAria: 'Supprimer la tranche {{index}}',
    addBand: 'Ajouter une tranche',
    bandChecksAria: 'Vérifications des tranches',
    simulateDistance: 'Simuler la distance routière (km)',
    completeBandsForCost: 'Complétez les tranches pour voir le coût.',
    enterValidDistance: 'Saisissez une distance routière valide.',
    costAtDistance: 'Coût de livraison à {{km}} km : {{price}}',
    previewHint:
      'Aperçu du prix de la tranche, avant tout seuil de livraison gratuite.',
    bandErrors: {
      count: 'Saisissez entre 1 et 30 tranches de distance.',
      lastBand:
        'Tranche {{index}} : la dernière tranche couvre toutes les distances supérieures.',
      distance:
        'Tranche {{index}} : saisissez une distance supérieure à la précédente, jusqu’à 1 000 km.',
      fee: 'Tranche {{index}} : saisissez un coût de 0 à 999 999,99 € avec au plus deux décimales.',
    },
  },
  payment: {
    sectionAria: 'Paiement de la commande',
    paid: 'Payée',
    markPaid: 'Marquer comme payée',
    paymentStatus: 'Statut du paiement',
    toPay: 'À payer',
    saving: 'Enregistrement du paiement…',
    specialStatusHint:
      'Les paiements de commandes en attente, remboursées ou annulées nécessitent une vérification spécifique.',
    updateError:
      'Impossible de mettre à jour le paiement. Rechargez la commande et réessayez.',
    branchUnavailable: 'Établissement indisponible.',
    deposit: {
      ariaLabel: 'Demander un acompte',
      title: 'Demander un acompte',
      intro:
        'Choisissez le pourcentage du total de {{total}}. Le client recevra un lien pour payer.',
      received: 'Reçu :',
      remaining: 'Reste à payer :',
      defaultUnavailable:
        'Liens de paiement indisponibles : configurez Stripe.',
      verifyBeforeNew:
        'Le paiement de cette commande doit être vérifié avant de demander un nouvel acompte.',
      creating: 'Création en cours…',
      linkCreated: 'Lien créé',
      createLinkFor: 'Créer un lien pour {{amount}}',
      requested: 'Acompte demandé : {{amount}}',
      customerLink: 'Lien client',
      messageSent: 'Message en cours d’envoi / envoyé',
      sending: 'Envoi en cours…',
      sendWhatsApp: 'Envoyer au client par WhatsApp',
      copied: 'Copié',
      copyLink: 'Copier le lien',
      copyFromField: 'Copiez le lien depuis le champ ci-dessus.',
      whatsAppHint:
        'Utilise le message « Lien de paiement » configuré dans le Centre de messages. Créer ou envoyer le lien ne marque pas la commande comme payée.',
      requestMismatch:
        'La demande renvoyée ne correspond pas à l’acompte choisi. Rechargez la commande.',
      requestUnavailable:
        'Demande indisponible. Le service API doit prendre en charge les acomptes sur les commandes.',
      sendNotConfirmed: 'Envoi non confirmé.',
      sendError:
        'Impossible d’envoyer le message. Vérifiez la configuration WhatsApp du message « Lien de paiement ».',
      invalidPaymentRequest: 'Demande de paiement non valide.',
      invalidPaymentLink: 'Lien de paiement non valide.',
    },
  },
  labels: {
    inArrivo: 'Entrantes',
    accettato: 'Acceptée',
    archiviato: 'Traitée',
    accept: 'Accepter la commande',
    archive: 'Marquer comme traitée',
    reopen: 'Rouvrir la commande',
    eliminato: 'Supprimée',
    nonConsegnato: 'Non livrée',
    delivery: 'Delivery',
    takeaway: 'À emporter',
    ricevuto: 'Reçue',
    presaInCarico: 'Prise en charge',
    confermato: 'Prise en charge',
    inAttesaDiPagamento: 'En attente de paiement',
    inLavorazione: 'En préparation',
    pronto: 'Prête',
    ritirato: 'Retirée',
    inConsegna: 'En cours de livraison',
    consegnato: 'Livrée',
    rifiutato: 'Refusée',
    annullato: 'Annulée',
    nonRitirato: 'Non retirée',
    consegnaFallita: 'Livraison échouée',
    daPagare: 'À payer',
    inAttesa: 'En attente',
    pagato: 'Payée',
    parzialmentePagato: 'Acompte reçu',
    unspecified: 'À définir',
    fallito: 'Échoué',
    rimborsato: 'Remboursée',
    cash: 'Espèces',
    card: 'Carte',
    takeCharge: 'Prendre en charge',
    reject: 'Refuser la commande',
    prepare: 'Démarrer la préparation',
    ready: 'Marquer comme prête',
    assign: 'Affecter un livreur',
    dispatch: 'Partir en livraison',
    collect: 'Confirmer le retrait',
    deliver: 'Confirmer la livraison',
    fail: 'Signaler un problème',
    cancel: 'Annuler la commande',
    cashPaid: 'Enregistrer le paiement en espèces',
    refund: 'Rembourser sur la carte',
    cashRefund: 'Enregistrer le remboursement en espèces',
    notCollected: 'Non retirée',
    active: 'À gérer',
    completed: 'Terminées',
    issues: 'Annulées / incidents',
    scheduleAsap: 'Dès que possible',
  },
};
